export default {
  'footer.tos': 'Terms of Use',
  'footer.privacy': 'Privacy Policy'
};
